var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9947 11.4009C21.5328 10.9541 22.3366 11.0253 22.7336 11.6012C24.6081 14.321 25.4801 17.6243 25.1726 20.9398C24.826 24.6775 23.0088 28.1243 20.1207 30.5222C17.2327 32.92 13.5104 34.0723 9.77278 33.7257C6.4573 33.4182 3.37063 31.9536 1.04202 29.6109C0.548909 29.1148 0.626713 28.3116 1.16488 27.8648L3.57174 25.8664C4.1099 25.4196 4.90292 25.5023 5.42474 25.9681C6.77154 27.1703 8.47614 27.9198 10.2956 28.0885C12.5382 28.2965 14.7715 27.6051 16.5043 26.1664C18.2372 24.7277 19.3275 22.6596 19.5355 20.417C19.7042 18.5976 19.281 16.7842 18.3469 15.2393C17.985 14.6407 18.0496 13.846 18.5878 13.3992L20.9947 11.4009Z",
    fill: "url(#paint0_linear_336_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0749 23.0451C10.5367 23.4919 9.73291 23.4207 9.33596 22.8447C7.46143 20.125 6.58944 16.8216 6.89692 13.5062C7.24356 9.76851 9.06078 6.32164 11.9488 3.92383C14.8368 1.52602 18.5591 0.373679 22.2968 0.720315C25.6122 1.0278 28.6989 2.49241 31.0275 4.83513C31.5206 5.33123 31.4428 6.13441 30.9047 6.58123L28.4978 8.57954C27.9596 9.02636 27.1666 8.94372 26.6448 8.47792C25.298 7.27571 23.5934 6.52619 21.774 6.35745C19.5314 6.14947 17.298 6.84087 15.5652 8.27956C13.8324 9.71824 12.742 11.7864 12.5341 14.029C12.3653 15.8484 12.7886 17.6618 13.7226 19.2067C14.0845 19.8053 14.0199 20.5999 13.4817 21.0468L11.0749 23.0451Z",
    fill: "url(#paint1_linear_336_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_5",
    x1: 20.6323,
    y1: 0.0647224,
    x2: 11.4372,
    y2: 34.3813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24D898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C39B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_5",
    x1: 20.6323,
    y1: 0.0647224,
    x2: 11.4372,
    y2: 34.3813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24D898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C39B9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.acf29da25d27be95a3293e3bc38f119e.svg";
export { ForwardRef as ReactComponent };